import {createAction} from '@reduxjs/toolkit';

export default createAction('FOOTPRINT_SET');
